<template>
  <a-spin :spinning="confirmLoading">
    <!--<j-form-container >-->
      <!--<a-form-model ref="form"  :rules="validatorRules" slot="detail">-->
        <a-tabs @change="changeTabs" :activeKey="tabsKey" default-active-key="1" size="large" :tab-bar-style="{marginBottom: '12px', paddingLeft: '16px'}" >
          <a-tab-pane loading="true" :tab="language['system.certificate.mrcCode']" key="1"  v-if="(!value.id)||(!!value.id&&tabsKey==1)">
            <!--<a-form-model ref="form" :model="value1" :rules="validatorRules" slot="detail" >-->
            <sys-certificate-mrc-code-form  ref="mrcCodeForm" :disabled="disabled" :islock="islock" :systemlist="systemlist" @ok="submitCallback"> </sys-certificate-mrc-code-form>
            <!--</a-form-model>-->
          </a-tab-pane>
          <a-tab-pane loading="true" :tab="language['system.certificate.cbCode']" key="2" v-if="(!value.id)||(!!value.id&&tabsKey==2)">
          <!--<a-tab-pane loading="true" :tab="language['system.certificate.cbCode']" key="2" v-if="(disabled||islock)?tabsKey==2:true">-->
            <sys-certificate-cb-code-form ref="cbCodeForm" :disabled="disabled" :islock="islock" :systemlist="systemlist" @ok="submitCallback"></sys-certificate-cb-code-form>
          </a-tab-pane>
        </a-tabs>
        <!--<a-row>
          <a-col :span="24">
            <a-form-model-item :label="language['common.file']+'('+(totalFileSize/1024/1024).toFixed(2)+'M)'" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <div v-if="!disabled&&!islock&&(totalFileSize>maxFileSize)"><span style='color: red'>* {{language['sysCertificate.warning.totalFileSizeIs']}}:{{(totalFileSize/1024/1024).toFixed(2)}}M;{{language['sysCertificate.warning.CannotExceed']}}{{maxFileSize/1024/1024}}M</span></div>
                <div v-if="!disabled&&!islock&&(fileList.length>maxFileNumber)"><span style='color: red'>* {{ language['sysCertificate.warning.totalFileNumberIs'] }}:{{fileList.length}} {{language['common.pcs']}};{{language['sysCertificate.warning.CannotExceed']}}{{maxFileNumber}} {{language['common.pcs']}},{{language['sysCertificate.warning.uploadCompressedFiles']}}</span></div>
                <div v-if="disabled">
                  <div v-if="!!this.model.filePaths">
                    <j-upload file-type="file" :uploadSource="`platform`" bizPath="null"
                      :newWindowOpen="`true`" :value="this.model.filePaths" @change="handleChange"
                      :beforeUpload="beforeUpload" @getAllFileList="getAllFileList" @handleDelete="handleFileDelete" :disabled="disabled"
                      :buttonVisible="!disabled&&!islock&&(totalFileSize<=maxFileSize)&&(fileList.length<=maxFileNumber)" :number="0" :multiple="true"></j-upload>
                  </div>
                  <div v-else>{{language['common.not']}}</div>
                </div>
                <div v-if="!disabled">
                  <j-upload file-type="file" :text="this.language['common.clickUpload']" :uploadSource="`platform`" bizPath="null" :uploadTips="uploadTips"
                    :newWindowOpen="`true`" :value="this.model.filePaths" @change="handleChange"
                    :beforeUpload="beforeUpload" @getAllFileList="getAllFileList" @handleDelete="handleFileDelete" :disabled="islock"
                    :buttonVisible="!disabled&&!islock&&(totalFileSize<=maxFileSize)&&(fileList.length<=maxFileNumber)" :number="0" :multiple="true"></j-upload>
                </div>

              <a-button type="primary" v-if="!!this.model.filePaths"  @click="downLoadAll">{{language['common.all']+language['download']}}</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>-->

      <!--</a-form-model>-->
   <!-- </j-form-container>-->
<!--    <div style="text-align: center" v-if="!disabled">
      <span style='color: #8c8c8c'>
         {{language['sysCertificate.warning.totalFileMaxNumber']}} {{maxFileNumber}} {{language['common.pcs']}},{{language['sysCertificate.warning.uploadCompressedFiles']}};{{language['sysCertificate.warning.totalFileMaxSize']}} {{maxFileSize/1024/1024}}M
      </span>
    </div>-->
  </a-spin>
</template>

<script>

  import { httpAction, getAction,getFileAccessHttpUrl,downloadFile,downloadFileAll } from '@/api/manage'
  import { ref } from 'vue';
  import SysCertificateMrcCodeForm from "./SysCertificateMrcCodeForm";
  import SysCertificateCbCodeForm from "./SysCertificateCbCodeForm"
  const getFileName=(path)=>{
    if(path.lastIndexOf("\\")>=0){
      let reg=new RegExp("\\\\","g");
      path = path.replace(reg,"/");
    }
    return path.substring(path.lastIndexOf("/")+1);
  }
  export default {
    name: 'SysCertificateForm',
    components: {
      SysCertificateMrcCodeForm,
      SysCertificateCbCodeForm,
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      systemlist:{
        type:[String,Array],
        required:false,
      },
      islock:{
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        // maxFileSize:100,
        maxFileSize:500*1024*1024,
        maxFileNumber:50,
        value:{},
        value1:{},
        value2:{},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        url: {
          add: "/sys/syscertificate/add",
          edit: "/sys/syscertificate/edit",
          queryById: "/system/syscertificate/"
        },
        totalFileSize:0,
        fileList:[],
        // islock:false,
        lockConfig:'',
        tabsKey:'1',
        // modelVlaue:{},
      }
    },
    computed: {
      /*fileList(){
        this.fileList.forEach(item=>{
          this.filePath.push(item.filePath);
        })
      },*/
      language() {
        return this.$store.getters.language
      },
      formDisabled(){
        return this.disabled
      },
      uploadTips(){
        return this.language['sysCertificate.warning.totalFileMaxNumber']+' '+this.maxFileNumber+' '+this.language['common.pcs']+","+this.language['sysCertificate.warning.uploadCompressedFiles']+';'+this.language['sysCertificate.warning.totalFileMaxSize']+' '+ (this.maxFileSize/1024/1024)+'M';
      }
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.value));
    },
    methods: {
      changeTabs(activeKey){
        this.tabsKey = activeKey;
      },


      add () {
        // this.modelDefault.certificateType =  1;
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.value = Object.assign({}, record);
        this.visible=true
        if(!!record.certificateType){
          this.tabsKey = record.certificateType;
          if(record.certificateType=='1'){
            this.$nextTick(()=>{
              this.$refs.mrcCodeForm.edit(record);
            })
          }else{
            this.$nextTick(()=>{
              this.$refs.cbCodeForm.edit(record);
            })
          }
        }else{
          this.tabsKey = '1'
          this.$nextTick(()=>{
            this.$refs.mrcCodeForm.edit(Object.assign({}, record));
          })
        }
      },
      submitForm (){
        const that = this;
        if(that.tabsKey==1){
          that.$refs.mrcCodeForm.submitForm();
        }else{
          this.$refs.cbCodeForm.submitForm();
        }
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
    }
  }
</script>
